import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the absolute value in-place.
*
* @module @stdlib/math/special/iabs
*
* @example
* var Float64Array = require( '@stdlib/array/float64' );
* var iabs = require( '@stdlib/math/special/iabs' );
*
* var x = new Float64Array( [ 1.0, -1.0, 0.0 ] );
*
* var y = iabs( x );
* // returns <Float64Array>[ 1.0, 1.0, 0.0 ]
*
* var bool = ( y === x );
* // returns true
*
* @example
* var array = require( '@stdlib/ndarray/array' );
* var iabs = require( '@stdlib/math/special/iabs' );
*
* var x = array( [ [ 1.0, -2.0 ], [ -3.0, 4.0 ] ] );
* // returns <ndarray>
*
* var y = iabs( x );
* // returns <ndarray>
*
* var v = y.get( 0, 1 );
* // 2.0
*
* var bool = ( y === x );
* // returns true
*/

// MAIN //
var main = __var_0__;


// EXPORTS //
export default main;
